<template>
  <div>
    <display
      v-if="modifier === 'display'"
      :general="general"
      :item="item">
    </display>
    <background-color
      v-if="modifier === 'backgroundColor'"
      :general="general"
      :item="item">
    </background-color>
    <border-color
      v-if="modifier === 'borderColor'"
      :general="general"
      :item="item">
    </border-color>
    <border-radius
      v-if="modifier === 'borderRadius'"
      :general="general"
      :item="item">
    </border-radius>
    <color
      v-if="modifier === 'color' && general"
      :general="general"
      :item="item">
    </color>
    <font-family
      v-if="modifier === 'fontFamily'"
      :general="general"
      :item="item">
    </font-family>
    <font-size
      v-if="modifier === 'fontSize'"
      :general="general"
      :item="item">
    </font-size>
    <height
      v-if="modifier === 'height'"
      :general="general"
      :item="item">
    </height>
    <width
      v-if="modifier === 'width'"
      :general="general"
      :item="item">
    </width>
  </div>
</template>

<script>
import BackgroundColor from './BackgroundColor';
import BorderColor from './BorderColor';
import BorderRadius from './BorderRadius';
import Color from './Color';
import FontFamily from './FontFamily';
import FontSize from './FontSize';
import Height from './Height';
import Width from './Width';
import Display from './Display';

export default {
  props: [
    'modifier',
    'general',
    'item',
  ],
  components: {
    BackgroundColor,
    BorderColor,
    BorderRadius,
    Color,
    FontFamily,
    FontSize,
    Height,
    Width,
    Display,
  },
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?84c54006
 **/